<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/130l8k5/tc-custom/9780830868742.jpg?1697119614377" alt="This image is the cover for the book Evil and the Justice of God"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evil and the Justice of God
      </h1>
      <p class="bookDescription body article font2">
        <p>Merit Award, 2007 Christianity Today Theology/Ethics Book  </p><p>With every earthquake and war, understanding the nature of evil and our response to it becomes more urgent. Evil is no longer the concern just of ministers and theologians but also of politicians and the media. We hear of child abuse, ethnic cleansing, AIDS, torture and terrorism, and rightfully we are shocked. But, N. T. Wright says, we should not be surprised. For too long we have naively believed in the modern idea of human progress. In contrast, postmodern thinkers have rightly argued that evil is real, powerful and important, but they give no real clue as to what we should do about it. In fact, evil is more serious than either our culture or our theology has supposed. How then might Jesus' death be the culmination of the Old Testament solution to evil but on a wider and deeper scale than most imagine? Can we possibly envision a world in which we are delivered from evil? How might we work toward such a future through prayer and justice in the present? These are the powerful and pressing themes that N. T. Wright addresses in this book that is at once timely and timeless.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N. T. Wright
      </h2>
      
      <p class="authorDescription body article"><p>A prolific writer of both scholarly and popular books, N. T. Wright has written over thirty books, including <em>Simply Christian, The Original Jesus, What Saint Paul Really Said, The Challenge of Jesus, The Meaning of Jesus, Jesus and the Victory of God</em> and the magisterial <em>Paul and the Faithfulness of God</em>. His N. T. Wright For Everyone Series includes commentaries covering the entire New Testament. Formerly bishop of Durham in England, Wright is research professor of New Testament and early Christianity at the University of St Andrews in Scotland. He was formerly canon theologian of Westminster Abbey and dean of Lichfield Cathedral. He also taught New Testament studies for twenty years at Cambridge, McGill and Oxford Universities. He has been a visiting professor at Harvard Divinity School, Hebrew University in Jerusalem, Gregorian University in Rome and many other institutions around the world. In addition to his many books, Wright reaches a broad audience through his frequent media appearances. A sought-after commentator, Wright writes frequently for newspapers in England, including the<em>Times, the Independent</em> and the <em>Guardian.</em> He has been interviewed numerous times by radio and television broadcasters on both sides of the Atlantic, including ABC, NBC, CNN, PBS and NPR.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5658ace0